/* eslint-disable import/prefer-default-export */
import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import ProjectConfiguration from '@appblocks/codegeneration/ProjectConfiguration';
import {
    CodeBlock,
    BlockType,
    SettingType,
    Define,
    ValidationMessageType,
    ValidationMessage,
    SettingState,
    Setting,
    TibboDataType,
} from '@appblocks/codegeneration/types';
import BaseNode from '@appblocks/codegeneration/Nodes/BaseNode';
import NodePort from '@appblocks/codegeneration/Nodes/NodePort';
import NodeParameter from '@appblocks/codegeneration/Nodes/NodeParameter';


export const getCodeBlocks = (feature: BaseNode): CodeBlock[] => {
    const blocks: CodeBlock[] = [];
    const project: ProjectConfiguration = feature.project;
    const TIMER = project.getFeature(feature.getSettingValue('TIMER'));
    if (!TIMER) {
        return blocks;
    }
    const TIMER_VAR_NAME = TIMER.getSettingValue('TIMER_NAME');
    const TIMER_NAME = `timer_${TIMER_VAR_NAME}`;

    const doneLinks = project.getNodeLinks(feature, 'done');
    const doneBlock = doneLinks.length > 0 ? `'****${doneLinks[0].getSourceId()}****'` : '';
    const links = project.getNodeLinks(feature, 'timer_start');
    for (let i = 0; i < links.length; i++) {
        const link = links[i];

        const time = project.getNodeParameter(link, 'time');
        blocks.push({
            location: link.getSourceId(),
            blockType: BlockType.CODE,
            id: link.getID(),
            template: `
${TIMER_NAME}=sys.timercountms + ${time} * 1000
${TIMER_NAME}_CURRENT_MS=${time} * 1000
${TIMER_VAR_NAME}=${time}
${TIMER_NAME}_repeat=${feature.getSettingValue('REPEAT')}
if ${TIMER_VAR_NAME} = 0 AND ${time} > 0 then
    ${TIMER_VAR_NAME} = 1
end if
#if TIMER_DEBUG_PRINT
    sys.debugprint("TIMER> ${TIMER_NAME} started for "+lstr(${time})+" at " + lstr(sys.timercountms) + "\\r\\n")
#endif
${doneBlock}`,
        });
    }

    return blocks;
};
